import React from "react"
import "./ComplianceCard.scss"
import OverviewCard from "../OverviewCard"
import ChangeText from "../ChangeText"
import PropTypes from "prop-types"
import {
  NR_MIN_OPPORTUNITIES,
  BSR_MIN_OPPORTUNITIES,
} from "../../helpers/sharedConstants"
import {
  ProgressChart,
  Tooltips,
} from "@swipesense/shared_components_v2/dist/index"
import { complianceAmountColor } from "../../helpers/sharedHelperFunctions"

const ComplianceCard = ({
  loading,
  title,
  compliance,
  opportunities,
  change,
  bsrCompliance,
}) => {
  return (
    <div className="ComplianceCard">
      <OverviewCard>
        <div className="card-title semi-bold">
          {title}
          <Tooltips
            children={""}
            text={`The percent change is the difference between the selected date
          range (e.g. August 1-31) and the previous period (e.g. July 1-31.)`}
          />
        </div>

        <div className={`divider ${loading ? "loading" : ""}`} />
        <div className="progress-card-container">
          <div className="progress-chart-container">
            {opportunities >
            (bsrCompliance ? BSR_MIN_OPPORTUNITIES : NR_MIN_OPPORTUNITIES) ? (
              <ProgressChart
                text={""}
                percentage={Math.round(compliance)}
                pathColor={complianceAmountColor(compliance)}
                trailColor={"#EDF2F6"}
              />
            ) : (
              <ProgressChart
                percentage={Math.round(compliance)}
                text={"No Data"}
                pathColor={complianceAmountColor(compliance)}
                trailColor={"#EDF2F6"}
              />
            )}
          </div>
          <div className="opportunities-container">
            <p className="heading-6 margin-right display-inline">
              {opportunities}
            </p>
            <p className="text-small display-inline">Opportunities</p>
          </div>
        </div>
        <div className="change-section">
          {loading ? (
            ""
          ) : (
            <ChangeText change={change} opportunities={opportunities} />
          )}
        </div>
      </OverviewCard>
    </div>
  )
}

ComplianceCard.propTypes = {
  title: PropTypes.string.isRequired,
  compliance: PropTypes.number,
  opportunities: PropTypes.number,
  change: PropTypes.number,
  loading: PropTypes.bool,
  bsrCompliance: PropTypes.bool,
}

ComplianceCard.defaultProps = {
  title: "",
  compliance: 0,
  change: 0,
  opportunities: 0,
}

export default ComplianceCard
